import { Tag } from "primereact/tag";
import { useCallback } from "react";

 
export interface QuotationStatusTagProps {
  quotationStatus: string;
}

export function QuotationStatusTag({ quotationStatus }: QuotationStatusTagProps) {
  const getSeverity = useCallback(() => {
    switch (quotationStatus) {
      case "STALE":
        return "yellowgreen";
      case "DONE":
        return "green";
      case "FOR_REVISION":
        return "red";
      case "WORKING_ON_IT":
        return "orange";
      case "NOT_STARTED":
        return "gray";
      case "RATES_UNAVAILABLE":
        return "purple";
    }
  }, [quotationStatus]);

  return (
    <div id="QuotationStatusTag" className="quotationStatus-tag">
      <Tag value={quotationStatus} style={{backgroundColor: getSeverity()}}></Tag>
    </div>
  );
}

export default QuotationStatusTag;
